import React from "react";
import styled from "@emotion/styled";
import { SVGComponent } from "@typings/svg-component";
import BlankEffectIcon from "@assets/icons/blank-effect.svg";

interface CardIllustrationProps {
	icon: SVGComponent;
}

export const CardIllustration: React.FC<CardIllustrationProps> = ({ icon: Icon }) => (
	<Container>
		<BlankEffectIcon width={144} height={144} />
		<StyledIcon>
			<Icon width={128} height={128} />
		</StyledIcon>
	</Container>
);

const Container = styled.div`
	position: relative;
`;

const StyledIcon = styled.div`
	position: absolute;
	top: 8px;
	left: 8px;
`;
